import { render, staticRenderFns } from "./ProjectWizardHeaderNav.vue?vue&type=template&id=56bbe1e0"
import script from "./ProjectWizardHeaderNav.vue?vue&type=script&lang=js"
export * from "./ProjectWizardHeaderNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports